import { FetchBaseQueryError, FetchBaseQueryMeta } from "@reduxjs/toolkit/query"
import { AssignedEmployeeOrderDetail } from "src/app/slices/dashboard.slice"

export const appConstants = {
  mainAppBarHeight: 64,
  userDrawerWidth: 300,
  dateFormat: "YYYY-MM-DD",
  hourTimeFormat: "HH:mm",
  timeFormat_hhmmA: "hh:mm A",
  dateTimeFormat_hhmmA: "DD-MM-YYYY hh:mm A",
  googleMapKey: import.meta.env.VITE_GOOGLE_MAP_KEY,
  googleMapId: import.meta.env.VITE_GOOGLE_MAP_ID,
  defaultRouteColor: "#F17C6D",
  orderRawHeight: 120,
  tmpRoutes: "tmpRoutes",
}

export type InvalidateTagsType = "Route Planning" | "Orders"

interface ApiCustomError {
  error?: string
  errorMessage?: string
  errorType?: string
  messageKey?: string
  stack?: string
}

export type CustomBackendError = {
  error: FetchBaseQueryError & { data: ApiCustomError }
  meta: FetchBaseQueryMeta
  isUnhandledError: boolean
}

/*  TODO: move to dashboard module  */
export const defaultEmployeeOrders: AssignedEmployeeOrderDetail = {
  grouped: {},
  individual: [],
  onTimeOrders: 0,
  delayedOrders: 0,
}

export enum OrderStatusEnum {
  ON_THE_WAY_TO_CUSTOMER = "ON_THE_WAY_TO_CUSTOMER",
  ON_THE_WAY_TO_PROVIDER = "ON_THE_WAY_TO_PROVIDER",
  COMPLETED = "COMPLETED",
  READY_FOR_HAULAGE = "READY_FOR_HAULAGE",
}

export enum MarkerTypes {
  CIRCLE = "CIRCLE",
  UNASSIGNED_ORDER = "UNASSIGNED_ORDER",
  INDIVIDUAL_ORDER = "INDIVIDUAL_ORDER",
  ROUTE_ORDER = "ROUTE_ORDER",
  PROVIDER = "PROVIDER",
  DRIVER = "DRIVER",
}

export type SortOrderType = "asc" | "desc"

export interface FilterState {
  haulerEmployeeIds: number[]
  haulerIds: number[]
  query: string | null
  sortBy: string
  sortOrder: SortOrderType
  stateList: OrderStatusEnum[]
}

export type ThemeMode = "light" | "dark" | "system"
